export const newFareInitialValues = {
  nuValor: null,
  dtEmissao: null,
  dtValidade: null,
};
